export const VARIANCE_ACTIONS = {
  CUSTOM: 'custom',
  ADD_TO_GM: 'add_to_gm',
  ADD_TO_CPQ: 'add_to_cpq',
  REMOVE_FROM_GM: 'remove_from_gm',
  REMOVE_FROM_CPQ: 'remove_from_cpq',
  REPLACE_PRODUCT: 'replace_product',
  CHANGE_PRICE: 'change_price',
  FORCE_EVIDENCE_MATCH: 'force_evidence_match',
  ASSIGN_BAC: 'assign_bac',
  DPE_ADD_ACTION: 'dpe_add_action',
  DPE_CANCEL_ACTION: 'dpe_cancel_action',
  DPE_CHANGE_PRICE_ACTION: 'dpe_change_price_action',
  EDIT_CHANGE: 'edit_change',
  UNDO_CHANGE: 'undo_change',
  CLEAR_INHERITED_CPQ: 'clear_inherited_cpq',
  VIEW_DETAILS: 'view_details',
};

export const VARIANCE_ACTION_LABELS = {
  [VARIANCE_ACTIONS.CUSTOM]: 'Add custom variance',
  [VARIANCE_ACTIONS.ADD_TO_GM]: 'Add to GM file',
  [VARIANCE_ACTIONS.ADD_TO_CPQ]: 'Add to CPQ file',
  [VARIANCE_ACTIONS.REMOVE_FROM_GM]: 'Remove from GM file',
  [VARIANCE_ACTIONS.REMOVE_FROM_CPQ]: 'Remove from CPQ file',
  [VARIANCE_ACTIONS.REPLACE_PRODUCT]: 'Replace product',
  [VARIANCE_ACTIONS.CHANGE_PRICE]: 'Change price',
  [VARIANCE_ACTIONS.FORCE_EVIDENCE_MATCH]: 'Force evidence match',
  [VARIANCE_ACTIONS.ASSIGN_BAC]: 'Assign product to BAC',
  [VARIANCE_ACTIONS.DPE_ADD_ACTION]: 'Add to DPE',
  [VARIANCE_ACTIONS.DPE_CANCEL_ACTION]: 'Remove from DPE',
  [VARIANCE_ACTIONS.DPE_CHANGE_PRICE_ACTION]: 'Change DPE price',
  [VARIANCE_ACTIONS.EDIT_CHANGE]: 'Edit change',
  [VARIANCE_ACTIONS.UNDO_CHANGE]: 'Undo change',
  [VARIANCE_ACTIONS.CLEAR_INHERITED_CPQ]: 'Undo automatic inheritance',
  [VARIANCE_ACTIONS.VIEW_DETAILS]: 'See details / link product',
};

export const VARIANCE_SOURCE_LABELS = {
  gm: 'GM file',
  cpq: 'CPQ file',
  dpe: 'DPE API',
  appsheet: 'AppSheet',
};

const withoutDpeActions = (actions, allowDpeActions) => (
  allowDpeActions ? actions : actions.filter((action) => !action.startsWith('dpe_'))
);

export const varianceActionsForSource = (source, { allowDpeActions = true } = {}) => {
  if (source === 'gm') {
    return [
      VARIANCE_ACTIONS.CUSTOM,
      VARIANCE_ACTIONS.ADD_TO_CPQ,
      VARIANCE_ACTIONS.REMOVE_FROM_GM,
      VARIANCE_ACTIONS.REPLACE_PRODUCT,
      VARIANCE_ACTIONS.CHANGE_PRICE,
    ];
  }
  if (source === 'cpq') {
    return [
      VARIANCE_ACTIONS.CUSTOM,
      VARIANCE_ACTIONS.ADD_TO_GM,
      VARIANCE_ACTIONS.REMOVE_FROM_CPQ,
      VARIANCE_ACTIONS.REPLACE_PRODUCT,
      VARIANCE_ACTIONS.CHANGE_PRICE,
    ];
  }
  if (source === 'appsheet') {
    return withoutDpeActions([
      VARIANCE_ACTIONS.CUSTOM,
      VARIANCE_ACTIONS.ADD_TO_GM,
      VARIANCE_ACTIONS.ADD_TO_CPQ,
      VARIANCE_ACTIONS.DPE_ADD_ACTION,
      VARIANCE_ACTIONS.DPE_CHANGE_PRICE_ACTION,
    ], allowDpeActions);
  }
  if (source === 'dpe') {
    return withoutDpeActions([
      VARIANCE_ACTIONS.CUSTOM,
      VARIANCE_ACTIONS.ADD_TO_GM,
      VARIANCE_ACTIONS.ADD_TO_CPQ,
      VARIANCE_ACTIONS.DPE_CHANGE_PRICE_ACTION,
      VARIANCE_ACTIONS.DPE_CANCEL_ACTION,
    ], allowDpeActions);
  }
  return [
    VARIANCE_ACTIONS.CUSTOM,
    VARIANCE_ACTIONS.ADD_TO_GM,
    VARIANCE_ACTIONS.ADD_TO_CPQ,
  ];
};

export const varianceActionTargetLabel = (actionType) => {
  if (actionType === VARIANCE_ACTIONS.ADD_TO_GM || actionType === VARIANCE_ACTIONS.REMOVE_FROM_GM) return 'GM file';
  if (actionType === VARIANCE_ACTIONS.ADD_TO_CPQ || actionType === VARIANCE_ACTIONS.REMOVE_FROM_CPQ) return 'CPQ file';
  return null;
};

export const varianceActionTargetFile = (actionType) => {
  if (actionType === VARIANCE_ACTIONS.ADD_TO_GM || actionType === VARIANCE_ACTIONS.REMOVE_FROM_GM) return 'gm';
  if (actionType === VARIANCE_ACTIONS.ADD_TO_CPQ || actionType === VARIANCE_ACTIONS.REMOVE_FROM_CPQ) return 'cpq';
  return null;
};

export const varianceActionExportLane = (actionType, source, target = null) => {
  if (actionType === VARIANCE_ACTIONS.FORCE_EVIDENCE_MATCH || actionType === VARIANCE_ACTIONS.ASSIGN_BAC) return 'none';
  const targetFile = target || varianceActionTargetFile(actionType);
  if (targetFile === 'gm' || actionType === VARIANCE_ACTIONS.ADD_TO_GM || actionType === VARIANCE_ACTIONS.REMOVE_FROM_GM) {
    return 'gm_correction';
  }
  if (targetFile === 'cpq' || actionType === VARIANCE_ACTIONS.ADD_TO_CPQ || actionType === VARIANCE_ACTIONS.REMOVE_FROM_CPQ) {
    return 'cpq_peoplesoft_adjustment';
  }
  if ((actionType === VARIANCE_ACTIONS.REPLACE_PRODUCT || actionType === VARIANCE_ACTIONS.CHANGE_PRICE) && source === 'gm') {
    return 'gm_correction';
  }
  if ((actionType === VARIANCE_ACTIONS.REPLACE_PRODUCT || actionType === VARIANCE_ACTIONS.CHANGE_PRICE) && source === 'cpq') {
    return 'cpq_peoplesoft_adjustment';
  }
  return 'none';
};
